import * as Modal from "@src/deprecatedDesignSystem/components/ModalComposition";
import { FC, useCallback, useState } from "react";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import { LibraryItemDetailPageCoverImage_CoverImageFragment } from "../LibraryItemDetailPageContainer.generated";
import Text from "@ui/text";
import { StyleSheet } from "aphrodite";
import { Button } from "@src/ui/button";
import CoverImage from "@src/components/ui/CoverImage";
import { useModal } from "@src/hooks/useModal";
import { Input } from "@src/ui/input";
import { CoverImage as CoverImageType } from "@src/types.generated";
import SimpleRichTextEditor from "./SimpleRichTextEditor";
import UpdateCoverImageMenu from "@src/components/libraryItemDetailPages/shared/UpdateCoverImageMenu";

export type EditLibraryItemModalData = {
  name: string;
  description: string;
  coverImage:
    | LibraryItemDetailPageCoverImage_CoverImageFragment
    | undefined
    | null;
};
type Props = {
  modalHeader: string;
  name: string;
  description: string;
  coverImage: CoverImageType | undefined | null;
  onSave: (data: EditLibraryItemModalData) => void;
  disableCoverImageEditing?: boolean;
};
const labelWidthPx = 96;

const EditLibraryItemModal: FC<Props> = (props) => {
  const { closeModal } = useModal();
  const [coverImage, setCoverImage] = useState<
    CoverImageType | undefined | null
  >(props.coverImage);
  const [name, setName] = useState(props.name);
  const [description, setDescription] = useState(props.description);
  const onSave = useCallback(() => {
    props.onSave({ name, description, coverImage });
  }, [coverImage, description, name, props]);
  return (
    <Modal.Modal>
      <Modal.ModalHeader>{props.modalHeader}</Modal.ModalHeader>
      <Modal.ModalBody>
        <AutoLayout width={425} direction="vertical" spaceBetweenItems={24}>
          <AutoLayout alignSelf="stretch" alignmentVertical="top">
            <Text
              type="P2"
              fontWeight="Medium"
              styleDeclaration={styles.labelWidth}
            >
              Cover
            </Text>
            <AutoLayout flex={1} className="relative aspect-video">
              <CoverImage
                editEnabled={false}
                style={{
                  flex: 1,
                  alignSelf: "stretch",
                }}
                coverImage={coverImage || undefined}
              />
              {!props.disableCoverImageEditing && (
                <UpdateCoverImageMenu
                  coverImage={coverImage}
                  setCoverImage={setCoverImage}
                />
              )}
            </AutoLayout>
          </AutoLayout>
          <AutoLayout alignSelf="stretch" alignmentVertical="center">
            <Text
              type="P2"
              fontWeight="Medium"
              styleDeclaration={styles.labelWidth}
            >
              Name
            </Text>
            <Input
              value={name}
              placeholder="New Hire Guide..."
              className="flex-1"
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </AutoLayout>
          <AutoLayout alignSelf="stretch">
            <Text
              type="P2"
              fontWeight="Medium"
              style={{ paddingTop: 9 }}
              styleDeclaration={styles.labelWidth}
            >
              Description
            </Text>
            <div style={{ width: `calc(100% - ${labelWidthPx}px)` }}>
              <SimpleRichTextEditor
                value={description}
                className="w-full"
                placeholder="This module will teach you..."
                onChange={(value) => {
                  setDescription(value);
                }}
              />
            </div>
          </AutoLayout>
          <AutoLayout
            alignSelf="stretch"
            alignmentHorizontal="right"
            marginTop={24}
            spaceBetweenItems={12}
          >
            <Button variant="outline" onClick={() => closeModal()}>
              Cancel
            </Button>
            <Button onClick={onSave}>Save</Button>
          </AutoLayout>
        </AutoLayout>
      </Modal.ModalBody>
    </Modal.Modal>
  );
};

const styles = StyleSheet.create({
  labelWidth: { width: labelWidthPx },
});

export default EditLibraryItemModal;
